export enum SavvyMoneyViewUrl {
  MobileWidget = "savvymoney_mobile_widget",
  WebDashboard = "savvymoney_web_dashboard",
  WebWidget = "savvymoney_web",
}
